// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-kOOSj {
	margin-bottom: 6px !important;
}

.Image-space2-tAI9w {
	margin-bottom: 12px !important;
}

.Image-space3-VwOMs {
	margin-bottom: 18px !important;
}

.Image-space4-nbWzg {
	margin-bottom: 24px !important;
}

.Image-space5-PAaAe {
	margin-bottom: 30px !important;
}

.Image-space6-mmZEC {
	margin-bottom: 36px !important;
}

.Image-space7-hoa7W {
	margin-bottom: 42px !important;
}

.Image-spaceTop8-ZoND2 {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-wngaN {
	margin-top: 6px !important;
}

.Image-spaceTop2-p8eAC {
	margin-top: 12px !important;
}

.Image-spaceTop3-YL9vo {
	margin-top: 18px !important;
}

.Image-spaceTop4-QqSLc {
	margin-top: 24px !important;
}

.Image-spaceTop5-WVpE8 {
	margin-top: 30px !important;
}

.Image-spaceTop6-lxXx9 {
	margin-top: 36px !important;
}

.Image-spaceTop7-tgMzb {
	margin-top: 42px !important;
}

.Image-spaceTop8-ZoND2 {
	margin-top: 48px !important;
}

.Image-noMargin-peBs6 {
	margin: 0px !important;
}

.Image-padding1-XVemf {
	padding-bottom: 6px !important;
}

.Image-padding2-dJqej {
	padding-bottom: 12px !important;
}

.Image-padding3-pvgE9 {
	padding-bottom: 18px !important;
}

.Image-padding4-mncO7 {
	padding-bottom: 24px !important;
}

.Image-padding5-dxjgH {
	padding-bottom: 30px !important;
}

.Image-padding6-iHwQI {
	padding-bottom: 36px !important;
}

.Image-padding7-UTiRR {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-J6x1T {
	padding-top: 6px !important;
}

.Image-paddingTop2-euoSz {
	padding-top: 12px !important;
}

.Image-paddingTop3-fhjgc {
	padding-top: 18px !important;
}

.Image-paddingTop4-HSKpO {
	padding-top: 24px !important;
}

.Image-paddingTop5-g67nF {
	padding-top: 30px !important;
}

.Image-paddingTop6-bf0vt {
	padding-top: 36px !important;
}

.Image-paddingTop7-ZNYby {
	padding-top: 42px !important;
}

.Image-noPadding-Qh2fa {
	padding: 0px !important;
}

.Image-textBold-uUcMO {
	font-weight: 500 !important;
}

.Image-textBolder-eP3rz {
	font-weight: 700 !important;
}

.Image-textNormal-cHEbh {
	font-weight: normal !important;
}

.Image-spaceBottom20-jAD19 {
	margin-bottom: 20px;
}

.Image-spaceBottom10-pFPia {
	margin-bottom: 10px;
}

.Image-marginNone-dbbdo {
	margin: 0;
}

.Image-spaceBottom15-g8Iga {
	margin-bottom: 15px;
}

.Image-marginTopNone-xmmPj {
	margin-top: 0;
}

.Image-spaceTop11-PnhjL {
	margin-top: 11px;
}

.Image-spaceTop21-sshUv {
	margin-top: 21px;
}

.Image-spaceTop20-Gd5Gv {
	margin-top: 20px;
}

.Image-spaceTop10-o5TOH {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image-textDarkBlue-zIcSx {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-cfMYE {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-XmNup {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-AGiSI {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-avJ8q {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-r9IFL {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-RxugO {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-nDsAr {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-poHbk {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-QIUhq {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-iLBGv {
	color: rgb(77, 65, 51) !important;
}

.Image-commonHeaderAdmin-z04dV {
	position: fixed !important;
}

.Image-adminLayout-qG0j5 {
	padding-top: 64px !important;
}

.Image-box-HWzaw h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image-exportLink-ORw_5 {
	margin-bottom: -29px;
}

.Image-blockCenter-E_JH0 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image-panelHeader-WXR2v {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image-currencyselect-dgc9n {
	width: 100%;
	margin-right: 0px;
}

.Image-panelHeader-WXR2v {
	overflow: hidden;
	position: relative;
}

.Image-mar0-bW68e {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image-blockCenter-E_JH0 {
		padding: 0px;
	}

	.Image-panelHeader-WXR2v {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image-sideAdminPageWrapper-d9ZoB {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image-panelHeader-WXR2v {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image-table-jRtnn {
	display: table;
}

.Image-tableRow-rNWOB {
	display: table-row;
}

.Image-tableCell-VYJMp {
	display: table-cell;
	float: none;
}

.Image-formGroup-LaKO7 {
	margin-bottom: 6px;
}

.Image-select-WmQKc {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image-noMargin-peBs6 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-ORw_5 {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-labelTextNew-ZloKg {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-displayInline-LwA2k {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image-btnUPdate-tAPPt {
	display: inline-block;
}

.Image-btnModalDelete-kJPvD {
	display: inline-block;
	margin-left: 15px;
}

.Image-radioBtn-T2jYb {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image-backgroundImg-r9cFB {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image-btnUPdate-tAPPt {
		display: block;
		margin-bottom: 12px;
	}

	.Image-btnModalDelete-kJPvD {
		display: block;
		margin-left: 0px;
	}

	.Image-btnWidth-GM8hw {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-AZDoM {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image-bannerDelete-N94_L {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image-modalRoot-Txc5U {
	padding: 32px;
}

.Image-modalBorderBottom-vMkcb {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image-logInModalBody-PkmWB {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image-exportSection-Hb5r_ {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image-exportSectionGridSub-t1mK0 {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-GtCkT {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image-exportLinkImg-fECgd {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image-vtrMiddle-sNFKl {
	vertical-align: middle;
}

.Image-exportImg-GEjmF {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-profileViewlabel-DTpd1 {
	display: inline-block;
	width: 38%
}

.Image-profileViewMainContent-fc2wk {
	display: inline-block;
	width: 62%;
}

.Image-profileViewMain-Or_dZ {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image-profileViewInner-KsVqa {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image-profileImageSection-mTQ2o {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image-lastviewInner-rSPs4 {
	padding: 10px;
}

.Image-whyHostHoriLine-g6RSi {
	margin: 30px 0;
}

.Image-tableGrid-MxhDz {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image-headingContent-V3T9_ {
	font-size: 18px;
	font-weight: 500;
}

.Image-refundTextColor-hQFih {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image-dividerLine-R0h_O {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image-smallContent-Z2kgn {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image-sideAdminPageWrapper-d9ZoB {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image-sideAdminPageWrapper-d9ZoB {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image-exportSection-Hb5r_ {
		grid-template-columns: 100%;
	}

	.Image-exportSectionGridSub-t1mK0 {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-DTpd1 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-fc2wk {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image-ChangeToUpperCase-BPgSb {
	text-transform: uppercase
}

.Image-noBorder-TCp1o {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image-siteAdminHeading-JAmSG {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-siteAdminSubHeading-Hks79 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-adminFormDivider-T3ViS {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-kOOSj`,
	"space2": `Image-space2-tAI9w`,
	"space3": `Image-space3-VwOMs`,
	"space4": `Image-space4-nbWzg`,
	"space5": `Image-space5-PAaAe`,
	"space6": `Image-space6-mmZEC`,
	"space7": `Image-space7-hoa7W`,
	"spaceTop8": `Image-spaceTop8-ZoND2`,
	"spaceTop1": `Image-spaceTop1-wngaN`,
	"spaceTop2": `Image-spaceTop2-p8eAC`,
	"spaceTop3": `Image-spaceTop3-YL9vo`,
	"spaceTop4": `Image-spaceTop4-QqSLc`,
	"spaceTop5": `Image-spaceTop5-WVpE8`,
	"spaceTop6": `Image-spaceTop6-lxXx9`,
	"spaceTop7": `Image-spaceTop7-tgMzb`,
	"noMargin": `Image-noMargin-peBs6`,
	"padding1": `Image-padding1-XVemf`,
	"padding2": `Image-padding2-dJqej`,
	"padding3": `Image-padding3-pvgE9`,
	"padding4": `Image-padding4-mncO7`,
	"padding5": `Image-padding5-dxjgH`,
	"padding6": `Image-padding6-iHwQI`,
	"padding7": `Image-padding7-UTiRR`,
	"paddingTop1": `Image-paddingTop1-J6x1T`,
	"paddingTop2": `Image-paddingTop2-euoSz`,
	"paddingTop3": `Image-paddingTop3-fhjgc`,
	"paddingTop4": `Image-paddingTop4-HSKpO`,
	"paddingTop5": `Image-paddingTop5-g67nF`,
	"paddingTop6": `Image-paddingTop6-bf0vt`,
	"paddingTop7": `Image-paddingTop7-ZNYby`,
	"noPadding": `Image-noPadding-Qh2fa`,
	"textBold": `Image-textBold-uUcMO`,
	"textBolder": `Image-textBolder-eP3rz`,
	"textNormal": `Image-textNormal-cHEbh`,
	"spaceBottom20": `Image-spaceBottom20-jAD19`,
	"spaceBottom10": `Image-spaceBottom10-pFPia`,
	"marginNone": `Image-marginNone-dbbdo`,
	"spaceBottom15": `Image-spaceBottom15-g8Iga`,
	"marginTopNone": `Image-marginTopNone-xmmPj`,
	"spaceTop11": `Image-spaceTop11-PnhjL`,
	"spaceTop21": `Image-spaceTop21-sshUv`,
	"spaceTop20": `Image-spaceTop20-Gd5Gv`,
	"spaceTop10": `Image-spaceTop10-o5TOH`,
	"textDarkBlue": `Image-textDarkBlue-zIcSx`,
	"textLightBlue": `Image-textLightBlue-cfMYE`,
	"textLightSandleGreen": `Image-textLightSandleGreen-XmNup`,
	"textLightBrown": `Image-textLightBrown-AGiSI`,
	"textMediumMaroon": `Image-textMediumMaroon-avJ8q`,
	"textBrown": `Image-textBrown-r9IFL`,
	"textMaroon": `Image-textMaroon-RxugO`,
	"textDarkBrown": `Image-textDarkBrown-nDsAr`,
	"textMediumBrown": `Image-textMediumBrown-poHbk`,
	"textSkyBlue": `Image-textSkyBlue-QIUhq`,
	"textGray": `Image-textGray-iLBGv`,
	"commonHeaderAdmin": `Image-commonHeaderAdmin-z04dV`,
	"adminLayout": `Image-adminLayout-qG0j5`,
	"box": `Image-box-HWzaw`,
	"exportLink": `Image-exportLink-ORw_5`,
	"blockCenter": `Image-blockCenter-E_JH0`,
	"panelHeader": `Image-panelHeader-WXR2v`,
	"currencyselect": `Image-currencyselect-dgc9n`,
	"mar0": `Image-mar0-bW68e`,
	"sideAdminPageWrapper": `Image-sideAdminPageWrapper-d9ZoB`,
	"table": `Image-table-jRtnn`,
	"tableRow": `Image-tableRow-rNWOB`,
	"tableCell": `Image-tableCell-VYJMp`,
	"formGroup": `Image-formGroup-LaKO7`,
	"select": `Image-select-WmQKc`,
	"labelTextNew": `Image-labelTextNew-ZloKg`,
	"displayInline": `Image-displayInline-LwA2k`,
	"btnUPdate": `Image-btnUPdate-tAPPt`,
	"btnModalDelete": `Image-btnModalDelete-kJPvD`,
	"radioBtn": `Image-radioBtn-T2jYb`,
	"backgroundImg": `Image-backgroundImg-r9cFB`,
	"btnWidth": `Image-btnWidth-GM8hw`,
	"bannerImageBg": `Image-bannerImageBg-AZDoM`,
	"bannerDelete": `Image-bannerDelete-N94_L`,
	"modalRoot": `Image-modalRoot-Txc5U`,
	"modalBorderBottom": `Image-modalBorderBottom-vMkcb`,
	"logInModalBody": `Image-logInModalBody-PkmWB`,
	"exportSection": `Image-exportSection-Hb5r_`,
	"exportSectionGridSub": `Image-exportSectionGridSub-t1mK0`,
	"exportText": `Image-exportText-GtCkT`,
	"exportLinkImg": `Image-exportLinkImg-fECgd`,
	"vtrMiddle": `Image-vtrMiddle-sNFKl`,
	"exportImg": `Image-exportImg-GEjmF`,
	"profileViewlabel": `Image-profileViewlabel-DTpd1`,
	"profileViewMainContent": `Image-profileViewMainContent-fc2wk`,
	"profileViewMain": `Image-profileViewMain-Or_dZ`,
	"profileViewInner": `Image-profileViewInner-KsVqa`,
	"profileImageSection": `Image-profileImageSection-mTQ2o`,
	"lastviewInner": `Image-lastviewInner-rSPs4`,
	"whyHostHoriLine": `Image-whyHostHoriLine-g6RSi`,
	"tableGrid": `Image-tableGrid-MxhDz`,
	"headingContent": `Image-headingContent-V3T9_`,
	"refundTextColor": `Image-refundTextColor-hQFih`,
	"dividerLine": `Image-dividerLine-R0h_O`,
	"smallContent": `Image-smallContent-Z2kgn`,
	"ChangeToUpperCase": `Image-ChangeToUpperCase-BPgSb`,
	"noBorder": `Image-noBorder-TCp1o`,
	"siteAdminHeading": `Image-siteAdminHeading-JAmSG`,
	"siteAdminSubHeading": `Image-siteAdminSubHeading-Hks79`,
	"adminFormDivider": `Image-adminFormDivider-T3ViS`
};
module.exports = ___CSS_LOADER_EXPORT___;
